export const ENVIRONMENT = {
  PROD: "PROD",
  STAGE: "STAGE",
  DEV: "DEV",
  QA: "QA",
  SIT: "SIT",
  PRE_PROD: "PRE_PROD",
};

export const ACTIONS = {
  SHOW_LOADER: "SHOW_LOADER",
  HIDE_LOADER: "HIDE_LOADER",
  GET_NOTIFICATION: "GET_NOTIFICATION",
  SET_NOTIFICATION: "SET_NOTIFICATION",
  CLEAR_NOTIFICATION: "CLEAR_NOTIFICATION",
  SET_SCREEN_SIZE: "SET_SCREEN_SIZE",
  SET_EARNINGS_DATA: "SET_EARNINGS_DATA",
  SET_ACTIVE_INACTIVE_DATA: "SET_ACTIVE_INACTIVE_DATA",
  SET_COMMISIONS_DATA: "SET_COMMISIONS_DATA",
  SET_LCO_ID_DATA: "SET_LCO_ID_DATA",
  SET_WINBACK_UPGRADE_DATA: "SET_WINBACK_UPGRADE_DATA",
  SET_TICKET_TRACKER_DATA: "SET_TICKET_TRACKER_DATA",
  SET_CONTACT_INFO_DATA: "SET_CONTACT_INFO_DATA",
  SET_USER_DATA: "SET_USER_DATA",
  SET_FORBIDDEN: "SET_FORBIDDEN",
  SET_CART_ITEM_COUNT: "SET_CART_ITEM_COUNT",
  SET_STATEMENT_DATA: "SET_STATEMENT_DATA",
  SET_PRODUCT_LIST_DATA: "SET_PRODUCT_LIST_DATA",
  SET_COMMON_CONFIG_DATA: "SET_COMMON_CONFIG_DATA",
  SET_CAPTURE_IMAGE: "SET_CAPTURE_IMAGE",
  ADD_INSURANCE: "ADD_INSURANCE",
  CLOSE_POP_UP: "CLOSE_POP_UP",
  DELETE_USER: "DELETE_USER",
  ADD_MEMBERS: "ADD_MEMBERS",
  EDIT_USER: "EDIT_USER",
  MANAGE_TEAM_ACTIVE_TAB: "MANAGE_TEAM_ACTIVE_TAB",
  SET_CDT_FILTERS: "SET_CDT_FILTERS",
  VIEW_QUERIES: "VIEW_QUERIES",
  RAISE_QUERY: "RAISE_QUERY",
  VIEW_INSURANCE_BENEFITS: "VIEW_INSURANCE_BENEFITS",
  SET_CIRCLE: "SET_CIRCLE",
  SET_CIRCLE_OPTIONS: "SET_CIRCLE_OPTIONS",
  SET_SCM_CART: "SET_SCM_CART",
  SET_SCM_CATALOG_FILTERS: "SET_SCM_CATALOG_FILTERS",
};

export const ROLES = {
  LCO_Project_Admin: "LCO_Project_Admin",
  CENTRAL_USER: "CENTRAL_USER",
  CIRCLE_USER: "CIRCLE_USER",
  CITY_USER: "CITY_USER",
  RM: "RM_USER",
  BDM: "BDM_USER",
  RESOLVER: "RESOLVER",
  WH_USER: "WH_USER",
  NETWORK_USER: "NETWORK_USER",
  PARTNER: "PARTNER",
  FRANCHISEE_BUSINESS_HEAD: "FRANCHISEE_BUSINESS_HEAD",
};

export const MAP_KEYS = {
  NO_OF_USERS: "noOfUsers",
  ARPU: "arpu",
  HOMEPASS: "homepass",
};

export const NOTIFICATIONGROUP = {
  APPROVAL: "APPROVAL",
  //  PROFILE_MANAGEMENT: "PROFILE_MANAGEMENT"
};

export const PARENT_KEYS = {
  ATTACHMENT: "ATTACHMENT",
  COMMENTS: "COMMENTS",
  ACTION: "ACTION",
  INFO: "INFO",
  TICKET_HISTORY: "TICKET_HISTORY",
  SEEK_CLARIFICATION: "SEEK_CLARIFICATION",
  RESOLVE: "RESOLVE",
  APPROVE: "APPROVE",
  REASSIGN: "REASSIGN",
  REJECT: "REJECT",
  SEEK_CLARIFICATION_COMMENTS: "SEEK_CLARIFICATION_COMMENTS",
  FILE_DOWNLOAD: "FILE_DOWNLOAD",
  COMPARE_CHECK: "COMPARE_CHECK",
  REDIRECTION_MENU: "REDIRECTION_MENU",
  RAISE_TICKET: "RAISE_TICKET",
  CONTACT_US: "CONTACT_US",
  REOPEN_TICKET: "REOPEN_TICKET",
  GIVE_CLARIFICATION: "GIVE_CLARIFICATION",
  SUBMIT_FEEDBACK: "SUBMIT_FEEDBACK",
  BASE: "BASE",
  PREPAID: "PREPAID",
  PAYOUT: "PAYOUT",
  VIEW_LICENSE: "VIEW_LICENSE",
  VIEW_DETAIL: "VIEW_DETAIL",
  MONEY: "MONEY",
  GST_STATUS: "GST_STATUS",
  ORDER_DETAIL: "ORDER_DETAIL",
  PARSEINTEGER: "PARSEINTEGER",
  ADHAARSTATUS: "ADHAARSTATUS",
  XFEACTION: "XFEACTION",
  VERIFICATION_STATUS: "VERIFICATION_STATUS",
  MEMBER_ROLE: "MEMBER_ROLE",
  CIRCLE: "CIRCLE",
  TOWN: "TOWN",
  POP: "POP",
  UPDATE_STATE: "UPDATE_STATE",
  DELETE_USER: "DELETE_USER",
  BULK_UPLOAD: "BULK_UPLOAD",
  ADD_INSURANCE: "ADD_INSURANCE",
  EDIT_USER: "EDIT_USER",
  ADD_MEMBERS: "ADD_MEMBERS",
  INSURANCE_STATUS: "INSURANCE_STATUS",
  TOGGLE: "TOGGLE",
  VERIFY_MEMBERS: "VERIFY_MEMBERS",
  VIEW_USER: "VIEW_USER",
  INSTALLMENT: "INSTALLMENT",
  STATUS: "STATUS",
  DOWNLOAD_INVOICE: "DOWNLOAD_INVOICE",
  VIEW_ORDER_DETAILS: "VIEW_ORDER_DETAILS",
  VIEW_INSTALLMENTS: "VIEW_INSTALLMENTS",
  VIEW_RECEIPTS: "VIEW_RECEIPTS",
  RAISE_DISPUTE: "RAISE_DISPUTE",
  VIEW_DETAILS: "VIEW_DETAILS",
  LOCATION: "LOCATION",
  VIEW_QUERIES: "VIEW_QUERIES",
  RAISE_QUERY: "RAISE_QUERY",
  VIEW_INSURANCE_BENEFITS: "VIEW_INSURANCE_BENEFITS",
  TERMINATE_PARTNERSHIP: "TERMINATE_PARTNERSHIP",
  ARCHIVED: "ARCHIVED",
};

export const paymentConstants = {
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  INITIALIZED: "INITIALIZED",
  PROCESSING: "PROCESSING",
};

export const monthNamesLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const monthNamesShort = [
  "Jan",
  "Feb",
  "March",
  "April",
  "May",
  "June",
  "July",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const monthNamesMap = {
  january: "Jan",
  february: "Feb",
  march: "Mar",
  april: "Apr",
  may: "May",
  june: "June",
  july: "July",
  august: "Aug",
  september: "Sep",
  october: "Oct",
  november: "Nov",
  december: "Dec",
};

export const TEXT = {
  RESOLVED: "RESOLVED",
  CLARIFICATION_REQUIRED: "CLARIFICATION_REQUIRED",
  PARTNER: "PARTNER",
  CAPTURE: "CAPTURE PHOTO",
  AADHARVERIFIED: "AADHAR_VERIFIED",
  PHOTOFAILED: "PHOTO_VERIFICATION_FAILED",
  VERIFIED: "Verified",
  NOTVERIFIED: "Not Verified",
  NEXT: "Next",
  PREVIOUS: "Previous",
  PERSONAL_POLICY: "Personal Policy",
  GROUP_POLICY: "Group Policy",
  PAID: "PAID",
  PARTIAL_PAID: "PARTIAL_PAID",
  NOT_PAID: "NOT_PAID",
  IN_PROCESS: "IN_PROCESS",
  OVERDUE: "OVERDUE",
  ORDER_DETAIL: "ORDER_DETAIL",
  ORDER_STATUS: "ORDER_STATUS",
  EDIT: "EDIT",
};

export const CONSENTMSG =
  "By clicking this checkbox and the Send OTP button, I voluntarily agree to Aadhaar eSign the previewed document. I also agree to be carrying out an e-authentication using Aadhaar e-KYC services for National Identity Document verification. I agree to accept such Certificate for its affixation to the previewed document.";

export const cdt = "Customer Down Time";

export const PolicyInsuranceActions = {
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

export const policyNumber = "4005/246512656/01/000";

export const sdPaymentCompliance = {
  stateName: "SD_PAYMENT_COMPLIANCE",
  consentRequired: "Consent Required",
  successToastMessage: "Consent submitted successfully!",
  otpFailureMessage: "Failed to send OTP. Please try again.",
  invalidOtpMessage: "Invalid OTP. Please try again.",
}
